
import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: "https://i.postimg.cc/s23TL95R/hero-image-1.jpg",
      title: "Immersive 360° Virtual Tours",
      description: "Explore our stunning virtual reality experiences designed to showcase spaces in breathtaking detail"
    },
    {
      image: "https://i.postimg.cc/pLf0k1hZ/hero-image-2.jpg",
      title: "Transform Your Business Presence",
      description: "Stand out from the competition with interactive 360° tours that engage and convert customers"
    }
  ];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slides.length]);
  
  return (
    <section 
      id="home" 
      className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
    >
      {/* Hero image — eager-loaded, high priority, explicit dimensions for LCP */}
      <img
        src={slides[currentSlide].image}
        alt={slides[currentSlide].title}
        width={1920}
        height={1080}
        {...({ fetchpriority: "high" } as any)}
        loading="eager"
        className="absolute inset-0 w-full h-full object-cover transition-all duration-1000 ease-in-out"
      />
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-vista-darker-gray bg-opacity-70"></div>
      
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-center text-white">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in">
          {slides[currentSlide].title}
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto animate-fade-in" style={{animationDelay: '0.2s'}}>
          {slides[currentSlide].description}
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-4 animate-fade-in" style={{animationDelay: '0.4s'}}>
          <Link to="/portfolio">
            <Button 
              className="bg-vista-blue hover:bg-vista-dark-blue text-white px-8 py-6 text-lg"
            >
              View Our Portfolio
            </Button>
          </Link>
          <Link to="/contact">
            <Button 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-vista-darker-gray px-8 py-6 text-lg bg-vista-darker-gray bg-opacity-50 shadow-lg"
            >
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
      
      {/* Slide indicators at bottom */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center">
        {slides.map((_, index) => (
          <button
            key={index}
            className="h-11 w-11 inline-flex items-center justify-center"
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          >
            <span
              className={`block h-3 w-3 rounded-full ${currentSlide === index ? 'bg-vista-blue' : 'bg-white/70'}`}
            />
          </button>
        ))}
      </div>
    </section>
  );
};

export default Hero;
